import { Rates } from './rates.entities';

export function getRatesMock(): Rates[] {
  return [
    {
      currency: 'Currency Rates',
      info: [
        {
          from: 'EUR',
          to: 'USD',
          toName: 'USD Tether (Tron)',
          value: 1.065_12,
        },
        {
          from: 'USD',
          to: 'EUR',
          toName: 'USD Tether (Tron)',
          value: 1.065_12,
        },
      ],
    },
    {
      currency: 'Top-up/Payout rates',
      info: [
        {
          from: 'USD',
          to: 'EUR',
          toName: 'USD',
          value: 1.065_12,
        },
        {
          from: 'USD',
          to: 'EUR',
          toName: 'USD',
          value: 1.065_12,
        },
        {
          from: 'USD',
          to: 'EUR',
          toName: 'USD',
          value: 1.065_12,
        },
      ],
    },
  ];
}
